export default __webpack_public_path__ + "static/video-59ef872133e684aa5684df5214358c8e.jpg";